import React from "react";
import { Link } from "react-router-dom";
import { questions } from "./Data";
import MainFAQ from "./MainFAQ";

/* this is the page show on the main landing page */
const QuestionAnswer = () => {
  return (
    <div className="relative">
      <MainFAQ questions={questions.slice(0, 4)} />

      <button className="absolute right-[20%]">
        <Link to="/AllFAQ">View All</Link>
      </button>
    </div>
  );
};

export default QuestionAnswer;
